import { AppBar, Layout, Menu, usePermissions } from "react-admin";
import { Divider, Typography, Box } from "@mui/material";
import BarChartIcon from "@mui/icons-material/BarChart";
import SecurityIcon from "@mui/icons-material/Security";

const MyAppBar = () => <AppBar color="primary" />;

const MyMenu = () => {
  const { permissions } = usePermissions();
  const hasCveAccess = permissions?.some(
    (perm: string) => perm === "admin" || perm.includes("cve")
  );
  const hasRmfAccess = permissions?.some(
    (perm: string) => perm === "admin" || perm.includes("rmf")
  );
  const hasRmfAnalyticsAccess = permissions?.some(
    (perm: string) => perm === "admin" || perm.includes("rmf_admin")
  );
  const hasAdminAccess = permissions?.some((perm: string) => perm === "admin");
  return (
    <Menu>
      <Menu.DashboardItem />
      {hasCveAccess && (
        <Menu>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ px: 2, py: 1 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight="bold"
            >
              CVE
            </Typography>
          </Box>
          <Menu.Item
            primaryText="Analytics"
            to="/cve/analytics"
            leftIcon={<BarChartIcon />}
          />
          <Menu.ResourceItem name="cve/code-sources" />
          <Menu.ResourceItem name="cve/code-cves" />
          <Menu.ResourceItem name="cve/image-sources" />
          <Menu.ResourceItem name="cve/image-builds" />
          <Menu.ResourceItem name="cve/image-cves" />
          <Menu.ResourceItem name="cve/releases" />
          <Menu.ResourceItem name="cve/tracked-cves" />
          <Menu.ResourceItem name="cve/sboms" />
          <Menu.ResourceItem name="cve/pre-releases" />
          <Menu.Item
            primaryText="Image Scan"
            to="/cve/endor-scan"
            leftIcon={<SecurityIcon />}
          />
        </Menu>
      )}
      {hasRmfAccess && (
        <Menu>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ px: 2, py: 1 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight="bold"
            >
              RMF
            </Typography>
          </Box>
          {hasRmfAnalyticsAccess && (
            <Menu.Item
              primaryText="Analytics"
              to="/rmf/analytics"
              leftIcon={<BarChartIcon />}
            />
          )}
          <Menu.ResourceItem name="rmf/employees" />
          <Menu.ResourceItem name="rmf/risks" />
        </Menu>
      )}
      {hasAdminAccess && (
        <Menu>
          <Divider sx={{ my: 1 }} />
          <Box sx={{ px: 2, py: 1 }}>
            <Typography
              variant="caption"
              color="text.secondary"
              fontWeight="bold"
            >
              Admin
            </Typography>
          </Box>
          <Menu.ResourceItem name="admin/api-tokens" />
        </Menu>
      )}
    </Menu>
  );
};

export const MyLayout = ({ children }: { children: React.ReactNode }) => (
  <Layout appBar={MyAppBar} menu={MyMenu}>
    {children}
  </Layout>
);
